import React, { useRef, useEffect } from "react";

import { Line } from '@antv/g2plot';

/**
 * 趋势折线图
 * 文档 https://github.com/antvis/G2Plot
 *  */
function Trend(props) {

    const {
        data, // 数据
        xField, // x轴取的字段
        yField, // y轴取的字段
        xAxis, // x轴样式
        yAxis, // x轴样式
        seriesField, // 每条线类型取的字段
        tooltip, // 点hover展示的东西
        style,
        ...resProps 
    } = props;

    const container = useRef(null);

    useEffect(() => {
        if (!container.current) {
            return;
        }
        if (data.length > 0) {
            LineChart();
        }
        // eslint-disable-next-line
    }, [data]);

    const LineChart = () => {
        if (container.current) {
            container.current.innerHTML = "";   // 强制重渲染。。。
        }
        const linePlot = new Line(container.current, {
            data,
            xField,
            yField,
            xAxis,
            yAxis,
            seriesField,
            tooltip,
            smooth: true,
            ...resProps
        })
        linePlot.render();
    }

    return <div ref={container} style={{ minHeight: '260px', minWidth: "200px", ...style }} />
}

export default Trend